
import React, { useState } from "react";
import TourShowcase from "../TourShowcase";
import { CloseIcon } from "./Icons";
import { safeUrl } from "./utils";

/**
 * Right-hand panel of the split view.
 *  - package has an id  -> visual showcase (TourShowcase.jsx)
 *  - no id / showcase failed -> the live page in an iframe (?embed=true)
 */
export default function PreviewPanel({ preview, onClose, onOpenPage }) {
  const [showcaseFailed, setShowcaseFailed] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(true);

  if (preview.id && !showcaseFailed) {
    return (
      <div className="flex-1 min-h-0 min-w-0 flex flex-col bg-white">
        <TourShowcase preview={preview} onClose={onClose} onOpenPage={onOpenPage} onError={() => setShowcaseFailed(true)} />
      </div>
    );
  }

  const url = safeUrl(preview.url);
  const embedUrl = `${url}${url.includes("?") ? "&" : "?"}embed=true`;

  return (
    <div className="flex-1 min-h-0 min-w-0 flex flex-col bg-white">
      <div className="bg-slate-900 text-white px-4 h-14 flex items-center justify-between shrink-0">
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-[11px] font-semibold text-sky-400 bg-sky-400/20 px-2 py-0.5 rounded-md whitespace-nowrap">Live Page</span>
          <h2 className="text-sm font-semibold truncate">{preview.title || "Tour Package"}</h2>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <a href={url}
            onClick={(e) => { if (onOpenPage) { e.preventDefault(); onOpenPage(preview.url); } }}
            className="text-xs bg-white/10 hover:bg-white/20 border border-white/15 rounded-md px-2.5 py-1 text-slate-100 no-underline">
            ↗ Open Page
          </a>
          <button type="button" onClick={onClose} aria-label="Close preview"
            className="p-1.5 rounded-md bg-red-500/15 text-red-300 hover:bg-red-500 hover:text-white transition-colors">
            <CloseIcon size={16} />
          </button>
        </div>
      </div>
      <div className="flex-1 relative bg-slate-50 min-h-0">
        {iframeLoading && (
          <div className="absolute inset-0 flex items-center justify-center text-sm text-slate-500 bg-slate-50/90 z-10">
            Loading live page...
          </div>
        )}
        <iframe src={embedUrl} title={preview.title || "TGH Webpage Preview"}
          className="w-full h-full border-0 block" onLoad={() => setIframeLoading(false)} />
      </div>
    </div>
  );
}
